import React from 'react';
import { AppConfig } from '../AppConfig';
import { BsCaretDownFill, BsCaretUpFill, BsCheckLg, BsPlusCircleDotted, BsXLg } from 'react-icons/bs';
import { Server } from 'src/server/server';
import MessageModal from '../modals/MessageModal';
import AlertModal from '../modals/AlertModal';
import NotFoundPage from './NotFoundPage';
import PageHeader from '../elements/PageHeader';
import './AdminThemePage.css';
import './SitePage.css';
import PageEnvelope from '../elements/PageEnvelope';

interface AdminThemePageState {
  palette: string[];
  color: string;
  googleFont: string;
  dirty: boolean;
  showPresets: boolean;
  showFonts: boolean;
  showGoogleFont: boolean;
  message: string;
  alert: string;
  styles: string[];
  body: boolean;
  header: boolean;
  menu: boolean;
  panel: boolean;
  input: boolean;
  button: boolean;
  iconButton: boolean;
  headerPanel: boolean;
  notification: boolean;
  dialog: boolean;
  loading: boolean;
}

class AdminThemePage extends React.Component<{}, AdminThemePageState> {
  constructor(props:{}) {
    super(props);
    this.state = {
      palette: [],
      color: '',
      googleFont: '',
      dirty: false,
      showPresets: false,
      showFonts: false,
      showGoogleFont: false,
      message: '',
      alert: '',
      styles: [],
      body: false,
      header: false,
      menu: false,
      panel: false,
      input: false,
      button: false,
      iconButton: false,
      headerPanel: false,
      notification: false,
      dialog: false,
      loading: true
    }
  }

  componentDidMount() {
    this.loadTheme(AppConfig.theme);
  }

  componentWillUnmount() {
    AppConfig.update();
  }

  loadTheme(theme:any) {
    let palette = [...theme.palette];
    let styles = {...theme.styles};
    this.setState({palette, styles, dirty: false, loading: false})
  }

  setFont(font:string) {
    let styles = {...this.state.styles};
    styles['body-font'] = font;

    this.setState({styles, dirty: true});

    let fontLink = document.getElementById('GoogleFontLink') as HTMLLinkElement;
    fontLink.href = `https://fonts.googleapis.com/css?family=${font}`;

    document.documentElement.style.setProperty('--body-font', font);
  }

  onFont(fi:number) {
    this.setFont(AppConfig.fonts[fi])
    this.setState({showFonts: false, dirty: true});
  }

  onShowGoogleFont() {
    this.setState({showGoogleFont: true, showFonts: false})
  }

  onGoogleFont() {
    this.setFont(this.state.googleFont)
    this.setState({showGoogleFont: false, dirty: true});
  }

  onPaletteColorChange(ci:number, value:string) {
    let palette = [...this.state.palette];
    palette[ci] = value;
    this.setState({palette, dirty: true});
    AppConfig.applyTheme(palette, this.state.styles);
  }

  onAddPaletteColor() {
    let palette = [...this.state.palette];
    palette.push(this.state.palette[this.state.palette.length-1]);
    this.setState({palette, dirty: true});
  }

  onPreset(pi:number) {
    // this.loadTheme(AppConfig.themes[ti]);
    let palette = AppConfig.palettes[pi];
    this.setState({palette, showPresets: false, dirty: true});
    AppConfig.applyTheme(palette, this.state.styles);
  }

  updateStyle(style:string, value:any) {
    let styles = {...this.state.styles};
    styles[style] = value;
    this.setState({styles, dirty: true});
    AppConfig.applyTheme(this.state.palette, styles);
  }

  onInputChange(style:string, value:string) {
    this.updateStyle(style, value);
  }

  onColorClick(style:string) {
    if(this.state.color == '')
      this.setState({color: style});
    else
      this.setState({color: ''});
  }

  onColorChange(ci:number) {
    this.updateStyle(this.state.color, ci)
  }

  onHeaderClick(state:string) {
    let newState = {};
    newState[state] = !this.state[state];
    this.setState(newState);
  }

  onRevert() {
    this.loadTheme(AppConfig.theme);
    AppConfig.update();
  }

  onSave() {
    this.setState({message: 'Saving...'});

    console.log(JSON.stringify(this.state.palette));
    console.log(JSON.stringify(this.state.styles));

    setTimeout(async () => {
      let oldPalette = {...AppConfig.community.theme.palette};
      let oldStyles = {...AppConfig.community.theme.styles};
      AppConfig.community.theme.palette = this.state.palette;
      AppConfig.community.theme.styles = this.state.styles;

      let response = await Server.user.updateCommunity(AppConfig.community);
      
      this.setState({message: ''});
      
      if(response.success) {
        window.localStorage.setItem('Community-' + AppConfig.community.slug, JSON.stringify(AppConfig.community));
        this.setState({dirty: false});
      }
      else {
        AppConfig.community.theme.palette = oldPalette;
        AppConfig.community.theme.styles = oldStyles;
        this.setState({alert: response.message});
      }
    }, 500);
  }

  renderFontsDropdown() {
    let divs = [];
    for(let i = 0; i < AppConfig.fonts.length; i++) {
      divs.push(
        <div 
          key={i}
          style={{borderRadius: '6px', fontFamily: AppConfig.fonts[i]}}
          onClick={()=>this.onFont(i)}
        >
          {AppConfig.fonts[i]}
        </div>
      )
    }

    divs.push(
      <div 
        key={AppConfig.fonts.length}
        style={{borderRadius: '6px'}}
        onClick={()=>this.onShowGoogleFont()}
      >
        Google Font...
      </div>
    )

    return (
      <div>
        <div className="site-page-dropdown" style={{top: '40px', left: '0px'}}>
          <div style={{display: 'flex', flexDirection: 'column', rowGap: '10px', margin: '10px'}}>
            {divs}
          </div>
        </div>
        <div className="site-page-dropdown-modal" />
      </div>
    )
  }

  renderFontSection() {
    let font = this.state.styles['body-font'];

    return (
      <div className="site-page-panel" style={{rowGap: '10px'}}>

        <div style={{display: 'grid', gridTemplateColumns: '60px 1fr 45px', alignItems: 'center'}}>
          <div>Font</div>     
          <div 
            className="admin-theme-page-font" 
            style={{fontFamily: font, position: 'relative'}}
            onClick={()=>this.setState({showFonts: !this.state.showFonts})}
          >
            {font}
            {this.state.showFonts && this.renderFontsDropdown()}
          </div>
          <button 
            className="site-page-icon-button" 
            style={{marginLeft: '5px', backgroundColor: 'transparent'}} 
            onClick={()=>this.setState({showFonts: !this.state.showFonts})}
          >
            <BsCaretDownFill/>
          </button>
        </div>

        <div style={{display: 'grid', gridTemplateColumns: '60px 1fr', alignItems: 'center'}}>
          <div>Scale</div>
          <div>
            <input 
              style={{width: '80px'}}
              value={this.state.styles['body-font-scale']}
              onChange={(e:any)=>this.onInputChange('body-font-scale', e.currentTarget.value)}
            />
          </div>
        </div>

      </div>
    )
  }

  renderGoogleFontSection() {
    return (
      <div className="site-page-panel" style={{rowGap: '5px'}}>
        <div>Font</div>     

        <div style={{display: 'grid', gridTemplateColumns: '1fr 45px 45px'}}>
          <input placeholder="Enter Google font name" value={this.state.googleFont} onChange={(e:any)=>this.setState({googleFont: e.currentTarget.value})}></input>
          <button 
            className="site-page-icon-button" 
            style={{marginLeft: '5px', backgroundColor: 'transparent'}} 
            onClick={()=>this.onGoogleFont()}
          >
            <BsCheckLg/>
          </button>
          <button 
            className="site-page-icon-button" 
            style={{marginLeft: '5px', backgroundColor: 'transparent'}} 
            onClick={()=>this.setState({showGoogleFont: false})}
          >
            <BsXLg/>
          </button>
        </div>

      </div>
    )
  }

  renderPresetsDropdown() {
    let divs = [];
    for(let i = 0; i < AppConfig.palettes.length; i++) {
      let colorDivs = [];
      for(let j = 0; j < AppConfig.palettes[i].length; j++) {
        colorDivs.push(
          <div key={j} style={{backgroundColor: AppConfig.palettes[i][j], flex: '1'}} />
        )
      }

      divs.push(
        <div 
          key={i}
          style={{overflow: 'hidden', borderRadius: '6px', padding: '0px', display: 'flex', flexDirection: 'column', border: '1px solid #00000020'}}
          onClick={()=>this.onPreset(i)}
        >
          <div style={{height: '30px', display: 'flex', flexDirection: 'row'}}>
            {colorDivs}
          </div>
        </div>
      )
    }

    return (
      <div>
        <div className="site-page-dropdown" style={{top: '20px', right: '0px', width: '200px'}}>
          <div style={{display: 'flex', flexDirection: 'column', rowGap: '5px', padding: '5px'}}>
            {divs}
          </div>
        </div>
        <div className="site-page-dropdown-modal" />
      </div>
    )
  }

  renderPaletteSection() {
    let colors = [];

    for(let i = 0; i < this.state.palette.length; i++) {
      colors.push(
        <input 
          key={i} 
          type="color" 
          value={this.state.palette[i]} 
          className="admin-theme-page-color-input" 
          style={{backgroundColor: this.state.palette[i]}}
          onChange={(e:any)=>this.onPaletteColorChange(i, e.currentTarget.value)}
        />
      )
    }

    colors.push(
      <div 
        key={this.state.palette.length} 
        className="admin-theme-page-color-input" 
        style={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}
        onClick={()=>this.onAddPaletteColor()}
      >
        <BsPlusCircleDotted />
      </div>
    )

    return (
      <div className="site-page-panel">
        <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'space-between'}}>
          <div>Color Palette</div>     
          <div 
            style={{fontSize: '0.9em', cursor: 'pointer', position: 'relative'}}
            onClick={()=>this.setState({showPresets: !this.state.showPresets})}
          >
            <u>Presets</u>
            {this.state.showPresets && this.renderPresetsDropdown()}            
          </div>       
        </div>
        
        <div style={{display: 'flex', flexDirection: 'row', columnGap: '10px', rowGap: '10px', flexWrap: 'wrap'}}>
          {colors}
        </div>
      </div>
    );
  }

  renderColorDropdown() {
    let colors = [];
    for(let i = 0; i < this.state.palette.length; i++) {
      colors.push(
        <div 
          key={i}
          style={{backgroundColor: this.state.palette[i], width: '30px', height: '30px', border: '1px solid #00000020'}}
          onClick={()=>this.onColorChange(i)}
        />
      )
    }

    return(
      <div>
        <div className="site-page-dropdown" style={{minWidth: '154px', top: '31px', right: '0px'}}>
          <div className="admin-theme-page-color-dropdown-content">
            {colors}
          </div>
        </div>
        <div className="site-page-dropdown-modal" />
      </div>
    )
  }

  renderPanelHeader(title:string, state:string) {
    return (
      <div className="site-page-row" style={{justifyContent: 'space-between', userSelect: 'none', cursor: 'pointer', backgroundColor: 'transparent', margin: '-5px', padding: '5px 0px 5px 5px'}} onClick={()=>this.onHeaderClick(state)}>
        <div>{title}</div>
        {this.state[state] ? <BsCaretUpFill /> : <BsCaretDownFill />}
      </div>
    )
  }

  renderColorRow(label:string, style:string) {
    let color = this.state.palette[this.state.styles[style]];
    if(!color)
      color = 'black';

    return (
      <div className="admin-theme-page-color-row">
        <div>{label}</div>
        <div 
          className="admin-theme-page-color-panel" 
          style={{backgroundColor: color}}
          onClick={()=>this.onColorClick(style)}
        >
          {this.state.color == style && this.renderColorDropdown()}
        </div>
      </div>
    )
  }

  renderInputRow(label:string, style:string) {
    let color = this.state.styles[style];
    if(!color)
      return null;

    return (
      <div className="admin-theme-page-color-row">
        <div>{label}</div>
        <input 
          style={{height: '10px'}} 
          value={this.state.styles[style]} 
          onChange={(e:any)=>this.onInputChange(style, e.currentTarget.value)} 
        />
      </div>
    )
  }

  renderBodyPanel() {
    return (
      <div className="site-page-panel">
        {this.renderPanelHeader('Body', 'body')}
        {this.state.body && 
          <div className="site-page-column admin-theme-page-column">
            <div>{this.renderColorRow('Background Color', 'body-background-color')}</div>
            <div>{this.renderColorRow('Text Color', 'body-color')}</div>
          </div>
        }
      </div>
    )
  }

  renderHeaderPanel() {
    return (
      <div className="site-page-panel admin-theme-page-panel">
        {this.renderPanelHeader('Header', 'header')}
        {this.state.header && 
          <div className="site-page-column admin-theme-page-column">
            <div>{this.renderColorRow('Background Color', 'header-background-color')}</div>
            <div>{this.renderColorRow('Text Color', 'header-color')}</div>
            <div>{this.renderInputRow('Font Size', 'header-font-size')}</div>
            <div>{this.renderColorRow('Button Color', 'header-button-background-color')}</div>
            <div>{this.renderColorRow('Button Text Color', 'header-button-color')}</div>
            <div>{this.renderInputRow('Button Border Width', 'header-button-border-width')}</div>
            <div>{this.renderColorRow('Button Border Color', 'header-button-border-color')}</div>
            <div>{this.renderInputRow('Button Border Radius', 'header-button-border-radius')}</div>
          </div>
        } 
      </div>
    )
  }

  renderMenuPanel() {
    return (
      <div className="site-page-panel admin-theme-page-panel">
        {this.renderPanelHeader('Menu', 'menu')}
        {this.state.menu && 
          <div className="site-page-column admin-theme-page-column">
            <div>{this.renderColorRow('Background Color', 'menu-background-color')}</div>
            <div>{this.renderColorRow('Button Color', 'menu-button-background-color')}</div>
            <div>{this.renderColorRow('Button Text Color', 'menu-button-color')}</div>
            <div>{this.renderColorRow('Active Button Color', 'menu-button-active-background-color')}</div>
            <div>{this.renderColorRow('Active Button Text Color', 'menu-button-active-color')}</div>
            <div>{this.renderInputRow('Button Font Size', 'menu-button-font-size')}</div>
          </div>
        } 
      </div>
    )
  }

  renderPanelPanel() {
    return (
      <div className="site-page-panel admin-theme-page-panel">
        {this.renderPanelHeader('Panel', 'panel')}
        {this.state.panel && 
          <div className="site-page-column admin-theme-page-column">
            <div>{this.renderColorRow('Background Color', 'panel-background-color')}</div>
            <div>{this.renderColorRow('Text Color', 'panel-color')}</div>
            <div>{this.renderColorRow('Sub Text Color', 'panel-subtext-color')}</div>
            <div>{this.renderInputRow('Border Width', 'panel-border-width')}</div>
            <div>{this.renderColorRow('Border Color', 'panel-border-color')}</div>
            <div>{this.renderInputRow('Border Radius', 'panel-border-radius')}</div>
            <div>{this.renderInputRow('Padding', 'panel-padding')}</div>
          </div>
        } 
      </div>
    )
  }

  renderHeaderPanelPanel() {
    return (
      <div className="site-page-panel admin-theme-page-panel">
        {this.renderPanelHeader('Header Panel', 'headerPanel')}
        {this.state.headerPanel && 
          <div className="site-page-column admin-theme-page-column">
            <div>{this.renderColorRow('Background Color', 'header-panel-background-color')}</div>
            <div>{this.renderColorRow('Text Color', 'header-panel-color')}</div>
          </div>
        } 
      </div>
    )
  }

  renderButtonPanel() {
    return (
      <div className="site-page-panel admin-theme-page-panel">
        {this.renderPanelHeader('Button', 'button')}
        {this.state.button && 
          <div className="site-page-column admin-theme-page-column">
            <div>{this.renderColorRow('Background Color', 'button-background-color')}</div>
            <div>{this.renderColorRow('Text Color', 'button-color')}</div>
            <div>{this.renderInputRow('Border Width', 'button-border-width')}</div>
            <div>{this.renderColorRow('Border Color', 'button-border-color')}</div>
            <div>{this.renderInputRow('Border Radius', 'button-border-radius')}</div>
            <div>{this.renderColorRow('Disabled Color', 'button-disabled-background-color')}</div>
            <div>{this.renderColorRow('Disabled Text Color', 'button-disabled-color')}</div>
            <div>{this.renderColorRow('Disabled Border Color', 'button-disabled-border-color')}</div>
          </div>
        } 
      </div>
    )
  }

  renderIconButtonPanel() {
    return (
      <div className="site-page-panel admin-theme-page-panel">
        {this.renderPanelHeader('Icon Button', 'iconButton')}
        {this.state.iconButton && 
          <div className="site-page-column admin-theme-page-column">
            <div>{this.renderColorRow('Background Color', 'icon-button-background-color')}</div>
            <div>{this.renderColorRow('Icon Color', 'icon-button-color')}</div>
            <div>{this.renderInputRow('Border Width', 'icon-button-border-width')}</div>
            <div>{this.renderColorRow('Border Color', 'icon-button-border-color')}</div>
            <div>{this.renderInputRow('Border Radius', 'icon-button-border-radius')}</div>
          </div>
        } 
      </div>
    )
  }

  renderInputPanel() {
    return (
      <div className="site-page-panel admin-theme-page-panel">
        {this.renderPanelHeader('Input', 'input')}
        {this.state.input && 
          <div className="site-page-column admin-theme-page-column">
            <div>{this.renderColorRow('Background Color', 'input-background-color')}</div>
            <div>{this.renderColorRow('Text Color', 'input-color')}</div>
            <div>{this.renderInputRow('Border Width', 'input-border-width')}</div>
            <div>{this.renderColorRow('Border Color', 'input-border-color')}</div>
            <div>{this.renderInputRow('Border Radius', 'input-border-radius')}</div>
          </div>
        } 
      </div>
    )
  }

  renderDialogPanel() {
    return (
      <div className="site-page-panel admin-theme-page-panel">
        {this.renderPanelHeader('Dialog', 'dialog')}
        {this.state.dialog && 
          <div className="site-page-column admin-theme-page-column">
            <div>{this.renderColorRow('Background Color', 'dialog-background-color')}</div>
            <div>{this.renderColorRow('Text Color', 'dialog-color')}</div>
          </div>
        } 
      </div>
    )
  }

  renderNotificationPanel() {
    return (
      <div className="site-page-panel admin-theme-page-panel">
        {this.renderPanelHeader('Notification', 'notification')}
        {this.state.notification && 
          <div className="site-page-column admin-theme-page-column">
            <div>{this.renderColorRow('Background Color', 'notification-background-color')}</div>
            <div>{this.renderColorRow('Text Color', 'notification-color')}</div>
          </div>
        } 
      </div>
    )
  }

  render() {
    if(Server.user.getRole() != 'admin')
      return(<NotFoundPage />);

    if(this.state.loading)
      return null;

    return(
      <div className="site-page">
        <PageEnvelope width="450px">
          <div className="site-page-column">
            <PageHeader text="Edit Theme" navigate="/admin" />

            {this.state.showGoogleFont ? this.renderGoogleFontSection() : this.renderFontSection()}

            {this.renderPaletteSection()}

            {this.renderBodyPanel()}
            {this.renderHeaderPanel()}
            {this.renderMenuPanel()}
            {this.renderPanelPanel()}
            {this.renderHeaderPanelPanel()}
            {this.renderButtonPanel()}
            {this.renderIconButtonPanel()}
            {this.renderInputPanel()}
            {this.renderDialogPanel()}
            {this.renderNotificationPanel()}

            <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'space-between', marginTop: '5px'}}>
              <button disabled={!this.state.dirty} onClick={()=>this.onRevert()}>Revert</button>
              <button disabled={!this.state.dirty} onClick={()=>this.onSave()}>Save</button>
            </div>
          </div>
        </PageEnvelope>

        <MessageModal message={this.state.message}/>
        <AlertModal message={this.state.alert} button="OK" onClose={()=>this.setState({alert: ''})} />
      </div>
    )
  }
}

export default AdminThemePage;